import React from 'react';
import _dialogLoader from '../../utilities/dialogLoader';

/**
 * @description 再下請負通知書のコメント詳細ダイアログ
 */
export class CommentDetail extends React.Component {
  render() {
    const { callbacks, state = {} } = this.props.dialog || {};
    const { comment, user_name, updated_at } = state;

    return (
      <div id='modal-dialog-confirm-selected' className='modal show'>
        <div className='dialog dialog--modal'>
          <div className='dialog__header'>
            <span className='dialog__title'>コメント</span>
          </div>
          <div className='dialog__body'>
            <div className='dialog-content'>
              <div className='dialog-content__commnet-header'>
                <div className='dialog-content__comment-header--item'>
                  <div className='dialog-content__label'>ユーザー名:</div>
                  <div className='dialog-content__comment-user'>
                    {user_name}
                  </div>
                </div>
                <div className='dialog-content__comment-header--item'>
                  <div className='dialog-content__label'>コメント日時:</div>
                  <div className='dialog-content__comment-date'>
                    {updated_at}
                  </div>
                </div>
              </div>
              <div className='dialog-content__body'>{comment}</div>
            </div>
          </div>
          <div className='dialog__footer--two-btn'>
            <button className='btn--sub' onClick={() => _dialogLoader.close()}>
              戻る
            </button>
            <button
              id='modal-submit-delete'
              className='btn--negative'
              onClick={() => callbacks.DeleteDialogShow()}
            >
              削除
            </button>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * @description 承認ダイアログ
 */
export const ApprovalDialog = ({ dialog }) => (
  <div className='modal show'>
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>提出された帳票を承認しますか？</span>
      </div>
      <div className='dialog-md__none-body' />
      <div className='labor-safety-constsys-ledger-notify__dialog-textarea'>
        <label>コメント *任意です。</label>
        <textarea
          name=''
          rows='3'
          onChange={e => dialog.callbacks.getComments(e.target.value)}
        />
      </div>
      <div className='dialog__footer labor-safety-constsys-ledger-notify__dialog-footer'>
        <button
          className='btn--sub sys-close-confirm-copy'
          onClick={() => _dialogLoader.close()}
        >
          戻る
        </button>
        <button
          className='btn--effective'
          onClick={dialog.callbacks.onApproval}
        >
          承認する
        </button>
      </div>
    </div>
  </div>
);

/**
 * @description 否認ダイアログ
 */
export const CanselDialog = ({ dialog }) => (
  <div id='modal-dialog-confirm-selected' className='modal show'>
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>提出された帳票を否認しますか？</span>
      </div>
      <div className='dialog-md__none-body' />
      <div className='labor-safety-constsys-ledger-notify__dialog-textarea'>
        <label>コメント *任意です。</label>
        <textarea name='' rows='3' />
      </div>
      <div className='dialog__footer labor-safety-constsys-ledger-notify__dialog-footer'>
        <button
          className='btn--sub sys-close-confirm-copy'
          onClick={() => _dialogLoader.close()}
        >
          戻る
        </button>
        <button className='btn--negative' onClick={dialog.callbacks.onCansel}>
          否認する
        </button>
      </div>
    </div>
  </div>
);

export const CompleteDialog = ({ dialog }) => (
  <div id='modal-dialog-confirm-selected' className='modal show'>
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>帳票の完成を完了しますか？</span>
      </div>
      <div className='dialog-md__body'>
        <div className='container'>
          <div className='container__col-left-center-12 labor-safety-constsys-ledger-notify__dialog-text'>
            帳票の作成を完了すると協力会社に
            <br />
            この帳票が公開されます。
          </div>
        </div>
      </div>
      <div className='labor-safety-constsys-ledger-notify__dialog-textarea'>
        <label>コメント *任意です。</label>
        <textarea name='' rows='3' />
      </div>
      <div className='dialog__footer labor-safety-constsys-ledger-notify__dialog-footer'>
        <button
          className='btn--sub sys-close-confirm-copy'
          onClick={() => _dialogLoader.close()}
        >
          戻る
        </button>
        <button
          className='btn--effective'
          onClick={dialog.callbacks.onComplete}
        >
          完了する
        </button>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/modals/LaborSafetyDialog.jsx